import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Lock } from "lucide-react";
import { Link } from "react-router";
import { toast } from "sonner";
import { api, ApiError } from "@/lib/api";
import { Button, Card } from "./ui";

/** Logiful-Team: Zwei-Faktor-Anmeldung vorschreiben (Logiful-Admins) */
export function StaffMfaCard() {
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ["admin-staff-mfa"], queryFn: api.security.staffMfa });
  const set = useMutation({
    mutationFn: (v: boolean) => api.security.setStaffMfa(v),
    onSuccess: (r) => { toast.success(r.required ? "Zwei-Faktor für das Logiful-Team vorgeschrieben" : "Nicht mehr vorgeschrieben"); void qc.invalidateQueries({ queryKey: ["admin-staff-mfa"] }); },
    onError: (e) => toast.error(e instanceof ApiError ? ((e.body as { message?: string })?.message ?? "Fehlgeschlagen") : "Fehlgeschlagen"),
  });
  if (!q.data) return null;
  const on = q.data.required;
  return (
    <Card className="mt-4 p-4 flex flex-wrap items-center gap-3">
      <Lock className="size-4 text-fg-subtle" />
      <div className="min-w-0 flex-1 basis-72">
        <p className="font-medium text-[13.5px]">Zwei-Faktor-Anmeldung für das Logiful-Team: {on ? <span className="text-success">vorgeschrieben</span> : <span className="text-fg-muted">freiwillig</span>}</p>
        <p className="text-[12.5px] text-fg-muted">Logiful-Mitarbeiter sehen alle Kunden – empfohlen: vorschreiben. Eigene Einrichtung unter <Link to="/settings/security" className="underline underline-offset-2">Sicherheit</Link>.</p>
      </div>
      <Button variant={on ? "secondary" : "primary"} loading={set.isPending} onClick={() => (on || confirm("Zwei-Faktor-Anmeldung für alle Logiful-Mitarbeiter vorschreiben? Wer sie noch nicht nutzt, muss sie sofort einrichten.")) && set.mutate(!on)}>
        {on ? "Freiwillig machen" : "Vorschreiben"}
      </Button>
    </Card>
  );
}
